module.exports = __webpack_public_path__ + "static/android-icon-192x192-24643aabaf133e37194799cbb2bc35b0.png";